/// <amd-module name="SuiteCommerce.ItemRecSys.Scenario"/>
define("SuiteCommerce.ItemRecSys.Scenario", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Scenario = exports.RecommendationUsecase = void 0;
    var RecommendationUsecase;
    (function (RecommendationUsecase) {
        RecommendationUsecase["SHOPPER_TRANSACTIONS_HISTORY"] = "SHOPPER_TRANSACTIONS_HISTORY";
        RecommendationUsecase["SESSION_RELATED_ITEMS"] = "SHOPPER_SESSION_RELATED_ITEMS";
        RecommendationUsecase["WHO_BOUGHT_ALSO_BOUGHT"] = "ITEM_WHO_BOUGHT_ALSO_BOUGHT";
        RecommendationUsecase["CHECKOUT_RELATED_ITEMS"] = "SHOPPER_CHECKOUT_RELATED_ITEMS";
        RecommendationUsecase["BUY_AGAIN"] = "SHOPPER_BUY_AGAIN";
        RecommendationUsecase["ALTERNATIVE_ITEMS"] = "ITEM_ALTERNATIVE_ITEMS";
    })(RecommendationUsecase || (exports.RecommendationUsecase = RecommendationUsecase = {}));
    var Scenario = /** @class */ (function () {
        function Scenario(dto) {
            this.id = dto.id;
            this.name = dto.name;
            this.usecase = dto.usecase;
            this.isInactive = dto.isinactive === 'T';
            this.isEligible = dto.eligible === 'T';
        }
        return Scenario;
    }());
    exports.Scenario = Scenario;
});
